import type { RegionalHighlightPurchaseOption } from '@/types/regionalHighlight';

const localeKeysForDistrictName = (locale: string): string[] => {
  const normalized = locale.trim();
  if (!normalized) {
    return [];
  }
  const language = normalized.split('-')[0];
  return language && language !== normalized ? [normalized, language] : [normalized];
};

/** Prefer localized `districtName` for UI; fall back to API `districtLabel` or id. */
const localizedDistrictName = (
  names: Record<string, string>,
  locale: string,
): string | undefined => {
  for (const key of localeKeysForDistrictName(locale)) {
    const label = names[key];
    if (label) {
      return label;
    }
  }
  return undefined;
};

export const regionalHighlightPurchaseDistrictLabel = (
  option: Pick<RegionalHighlightPurchaseOption, 'districtId' | 'districtLabel' | 'districtName'>,
  locale: string,
): string => {
  const fromMap = option.districtName
    ? localizedDistrictName(option.districtName, locale)
    : undefined;
  return fromMap ?? option.districtLabel ?? option.districtId;
};
